export default "__VITE_ASSET__CVIfKlk1__"